import { Checkbox as BaseCheckbox } from "@chakra-ui/react";

export default BaseCheckbox;
